import { ReactNode, useEffect, useState } from 'react';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import { formatNumberToLocale, PACKS_BY_ID, PACKS_BY_NAME } from '@/utils';

export const usePaymentTitle = () => {
  const { isDesktop } = useIsDesktop();
  const { pinsData } = usePinsAccount();
  const [title, setTitle] = useState<string | ReactNode>();

  useEffect(() => {
    if (
      pinsData.selectedProduct &&
      pinsData.selectedProduct.id !== PACKS_BY_ID[PACKS_BY_NAME.PACK_1]
    ) {
      if (
        [
          PACKS_BY_ID[PACKS_BY_NAME.PIN_ESPECIAL_TDA_1],
          PACKS_BY_ID[PACKS_BY_NAME.PIN_ESPECIAL_TDA_2],
          PACKS_BY_ID[PACKS_BY_NAME.PIN_ESPECIAL_TDA_3],
        ].includes(pinsData.selectedProduct.id)
      ) {
        if (isDesktop) {
          return setTitle(
            <>
              <h3>
                Estás por adquirir un Pin Especial ${' '}
                {formatNumberToLocale(pinsData.selectedProduct.precio)}
              </h3>
              <p className="font-normal mt-2 text-sm mb-6">
                Con la adquisición de este pin estarás participando
                automáticamente de un Torneo de Amigos por un premio de{' '}
                <strong>
                  $
                  {formatNumberToLocale(
                    pinsData.selectedProduct.montoPremio ||
                      pinsData.selectedProduct.precio * 10
                  )}
                </strong>{' '}
                para el ganador.
              </p>
            </>
          );
        } else {
          return setTitle(
            'Compra de Pin Especial Torneo de Amigos por Premios'
          );
        }
      } else if (
        [PACKS_BY_ID[PACKS_BY_NAME.PIN_FECHA_ORO]].includes(
          pinsData.selectedProduct.id
        )
      ) {
        if (isDesktop) {
          return setTitle(
            <>
              <h3>
                Estás por adquirir un Pin Especial ${' '}
                {formatNumberToLocale(pinsData.selectedProduct.precio)}
              </h3>
              <p className="font-normal mt-2 text-sm mb-6">
                Con la adquisición de este pin vas a poder participar de la
                Fecha de Oro por un premio de{' '}
                <strong>
                  $
                  {formatNumberToLocale(
                    pinsData.selectedProduct.montoPremio ||
                      pinsData.selectedProduct.precio * 10
                  )}
                </strong>{' '}
                para el ganador. Recordá que luego de adquirir el pin deberás
                ingresarlo en la pantalla de Fecha de Oro.
              </p>
            </>
          );
        } else {
          return setTitle('Compra de Pin Especial Fecha de Oro');
        }
      } else if (
        pinsData.selectedProduct.id === PACKS_BY_ID[PACKS_BY_NAME.PREMIUM] ||
        pinsData.selectedProduct.id === PACKS_BY_ID[PACKS_BY_NAME.PREMIUM_1]
      ) {
        return setTitle('Pack Premium');
      }

      setTitle(`Pack ${pinsData.selectedProduct.cantidad} Pines`);
    } else if (pinsData.moneyToWallet) {
      setTitle(`Cargar $${formatNumberToLocale(pinsData.moneyToWallet)}`);
    } else {
      setTitle('1 Pin');
    }

    return () => {
      setTitle('');
    };
  }, [pinsData.selectedProduct, pinsData.moneyToWallet, isDesktop]);

  return title;
};
